<div class="row">
  <div class="col">
    @if (modal) {
      <ng-container *ngTemplateOutlet="mainContent"></ng-container>
    } @else {
      <div class="card">
        <ng-container *ngTemplateOutlet="mainContent"></ng-container>
      </div>
    }
  </div>
</div>

<ng-template #mainContent>
  @if (displayHeader) {
    <div [class.card-header]="!modal">
      <h1>{{ pageTitle }}</h1>
    </div>
  }
  <div [class.card-body]="!modal">
    <h2>{{ 'change_password' | translate }}</h2>
    @if (isNotUsingExternalIdp) {
      <app-change-password
        [showSubmitButton]="!modal"
        (passwordChangeSuccess)="passwordChangeSuccess.emit()"
        (passwordChangeError)="passwordChangeError.emit()"
      ></app-change-password>
    }
    @if (modal) {
      <app-user-mfa
        [mfaStatusResponse$]="mfaStatusResponse$"
        (enableMfa)="enableMfa()"
        (disableMfa)="disableMfa()"
      ></app-user-mfa>
      <hr />
    }

    <app-deactivate-account></app-deactivate-account>
  </div>
</ng-template>
